export default "__VITE_ASSET__Gu5p_Fcz__"